import { useEffect, useState } from "react";
import type { Product } from "@shared/types";
import { api } from "@/lib/api";
import { StorefrontLayout } from "@/components/StorefrontLayout";
import { ProductCard } from "@/components/ProductCard";
import { SearchIcon } from "@/components/icons";

export function Search() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handle = setTimeout(() => {
      setLoading(true);
      api.products
        .list(query ? { q: query } : undefined)
        .then(setResults)
        .catch(() => setResults([]))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(handle);
  }, [query]);

  return (
    <StorefrontLayout>
      <div className="px-5 pb-8 pt-5">
        <div className="flex items-center gap-2 rounded-pill border border-stone-300 bg-white px-4 py-3">
          <SearchIcon className="text-stone-500" />
          <input
            autoFocus
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search handbags, totes, accessories…"
            className="flex-1 bg-transparent text-sm text-ink placeholder:text-stone-500 focus:outline-none"
          />
        </div>

        {loading ? (
          <p className="py-10 text-center text-sm text-stone-500">Searching…</p>
        ) : results.length === 0 ? (
          <p className="py-10 text-center text-sm text-stone-500">
            {query ? "No results. Try a different search." : "Start typing to search the catalog."}
          </p>
        ) : (
          <div className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6">
            {results.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </StorefrontLayout>
  );
}
